import React, { useState } from 'react';
import classNames from 'classnames';

import SVG from 'components/base/SVG';

import css from './style.scss';

// Actions dropdown — Figma "action dropdown" (299:10214), the panel that hangs
// off the teal Actions pill in the results header (291:7911).
//
// The Figma component set has Collapsed/Expanded variants keyed on the "New
// Campaign Activity" row, so the two channel rows are a submenu the user opens
// rather than five flat items; the frame that was shared shows the Expanded
// one. It starts collapsed here — the caret points down until the row is
// clicked — because that is the variant a freshly opened menu maps to.
//
// Icons: iconInvestorSkipTrace (the magnifier-and-person this epic already
// added) and iconCampaigns are reused from the sprite. Two came from the
// design's own exported vectors because the sprite had no match --
// iconInvestorAddToList (playlist_add) and iconInvestorPlus. The latter is NOT
// the sprite's existing iconPlus: that one is a 25x25 plus whose arms span the
// whole box, so at 20px it renders far heavier than the design's small centred
// plus (arms 5->15, 2px thick in a 20x20 box).
// `disabled` covers the no-selection case: the menu still opens (the design
// shows it open over an unselected list), but every action that needs records
// to act on is dimmed and inert until the user ticks at least one investor.
// "New Campaign Activity" still expands, so the channels stay discoverable.
const ActionsMenu = ({ disabled, onSkipTrace, onAddToInvestorList, onDialer, onEmail }) => {
  const [campaignOpen, setCampaignOpen] = useState(false);

  return (
    <div className={css.actionsMenu__panel}>
      <button
        type="button"
        className={classNames(css.actionsMenu__item, {
          [css['actionsMenu__item--disabled']]: disabled,
        })}
        disabled={disabled}
        onClick={onSkipTrace}
      >
        <SVG icon="iconInvestorSkipTrace" className={css.actionsMenu__icon} />
        <span className={css.actionsMenu__label}>Skip Trace</span>
      </button>

      <button
        type="button"
        className={classNames(css.actionsMenu__item, {
          [css['actionsMenu__item--disabled']]: disabled,
        })}
        disabled={disabled}
        onClick={onAddToInvestorList}
      >
        <SVG icon="iconInvestorAddToList" className={css.actionsMenu__icon} />
        <span className={css.actionsMenu__label}>Add to Investor List</span>
      </button>

      <button
        type="button"
        className={css.actionsMenu__item}
        aria-expanded={campaignOpen}
        onClick={() => setCampaignOpen(!campaignOpen)}
      >
        <SVG icon="iconCampaigns" className={css.actionsMenu__icon} />
        <span className={css.actionsMenu__label}>New Campaign Activity</span>
        <SVG
          icon="iconInvestorActionsCaret"
          className={classNames(css.actionsMenu__caret, {
            [css['actionsMenu__caret--up']]: campaignOpen,
          })}
        />
      </button>

      {campaignOpen && (
        <>
          <button
            type="button"
            className={classNames(css.actionsMenu__item, css['actionsMenu__item--nested'], {
              [css['actionsMenu__item--disabled']]: disabled,
            })}
            disabled={disabled}
            onClick={onDialer}
          >
            <SVG icon="iconInvestorPlus" className={css.actionsMenu__icon} />
            <span className={css.actionsMenu__label}>Dialer</span>
          </button>

          <button
            type="button"
            className={classNames(css.actionsMenu__item, css['actionsMenu__item--nested'], {
              [css['actionsMenu__item--disabled']]: disabled,
            })}
            disabled={disabled}
            onClick={onEmail}
          >
            <SVG icon="iconInvestorPlus" className={css.actionsMenu__icon} />
            <span className={css.actionsMenu__label}>Email</span>
          </button>
        </>
      )}
    </div>
  );
};

export default ActionsMenu;
